import {
  AuthFormInputSpan2,
  Body,
  Cell,
  CellTitle,
  CellValue,
  Footer,
  FormButton2,
  FormButtonCancel3,
  Row,
  Title,
} from "./styles";
import { ContainerRow } from "../../../components/Container";
import {
  errorView,
  formatCurrency,
  postWithdrawConfirm,
  postWithdrawConfirmV2,
  postWithdrawSendCode,
} from "../../../services/app";
import React, { useEffect, useState } from "react";
import { useApp } from "../../../contexts";
import {
  InfoIcon,
  InfoTooltipIcon,
  TooltipView,
  WalletDetailNotify,
} from "../../wallet-detail/styles";
import { AuthFormInput } from "../../auth/styles";
import { Form } from "antd";
import produce from "immer";
import Modal from "../../../components/Modal/Modal";
import FormInput from "../../../components/FormCustom2/Input";
import { useVerificationMethod } from "../../../components/ModalVerificationMethod/useVerificationMethod";
import * as Notification from "../../../Notification";
import { useSearchParams } from "react-router-dom";
import { decodeText, encodeText } from "../../../utils/helper";

export default function ModalWithdraw(props) {
  const {
    T,
    currencies,
    setLoading,
    setAlert,
    isUserSocial,
    getCurrency,
    loading,
  } = useApp();
  const [searchParams, setSearchParams] = useSearchParams();
  const onClose = props.onClose;
  const [row, setRow] = useState({ ...(props.value || {}) });
  const [password, setPassword] = useState("");
  useEffect(() => {
    if (searchParams.get("password")) {
      const passwordEncoded = searchParams.get("password");
      const passwordDecoded = decodeText(decodeURIComponent(passwordEncoded));
      setPassword(passwordDecoded);
      form.setFieldValue("password", passwordDecoded);
    } else {
      setPassword("");
      form.setFieldValue("password", "");
    }
  }, [searchParams]);
  const [editAble, setEditAble] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form] = Form.useForm();

  const getNameByCode = (code) => {
    return (currencies || []).find((item) => item.code === code)?.name || "";
  };

  const verification = useVerificationMethod();

  useEffect(() => {
    if (searchParams.get("line_connected") && searchParams.get("password")) {
      setTimeout(() => {
        onSubmit({
          chooseMethod: true,
        });
        setSearchParams(
          (searchParams) => {
            searchParams.delete("line_connected");
            return searchParams;
          },
          {
            replace: true,
          }
        );
      }, 500);
    }
  }, [searchParams]);

  const onSubmit = async (options) => {
    // submit password and data
    const res = await withDrawConfirmPassword();
    if (res) {
      verification.verify({
        chooseMethod: options?.chooseMethod,
        actionText: T("Withdraw"),
        skipTwoFa: !row.is_twofa,
        sendOtp: async (method) => {
          setLoading(true);
          try {
            const res = await postWithdrawSendCode(row?.id, method);
            if (res.status === 200) {
              return {
                success: true,
              };
            } else {
              return {
                success: false,
                message: res?.data?.error?.message || T("Failed to send OTP"),
              };
            }
          } catch (error) {
            console.error("Error sending OTP:", error);
            return {
              success: false,
              message:
                error?.response?.data?.error?.message ||
                T("Failed to send OTP"),
            };
          } finally {
            setLoading(false);
          }
        },
        verifyOtp: async (method, otp) => {
          const res = await postWithdrawConfirmV2({
            transactionId: row?.id,
            destWalletAddress: row?.dest_wallet_address || "",
            verificationCode: otp,
          });
          if (res.status === 200) {
            return {
              success: true,
            };
          } else {
            return {
              success: false,
              otpError:
                res?.data?.error?.message ?? T("Invalid verification code"),
            };
          }
        },
        action: async (method, otp, twoFa) => {
          try {
            setLoading(true);
            const result = await postWithdrawConfirmV2({
              transactionId: row?.id,
              destWalletAddress: row?.dest_wallet_address || "",
              verificationCode: !row?.is_twofa ? otp : undefined,
              twofaCode: !!row?.is_twofa ? twoFa : undefined,
            });
            if (result.status === 200) {
              onClose("success");
              return {
                success: true,
              };
            } else {
              return {
                success: false,
                twoFaError: !!row?.is_twofa
                  ? result?.data?.error?.message ??
                    T("Invalid verification code")
                  : undefined,
                otpError: !row?.is_twofa
                  ? result?.data?.error?.message ??
                    T("Invalid verification code")
                  : undefined,
              };
            }
          } catch (error) {
            console.error("Error confirming withdrawal:", error);
            Notification.error(
              error?.response?.data?.error?.message ??
                T("Failed to confirm withdrawal request")
            );
            return {
              success: false,
              twoFaError: !!row?.is_twofa
                ? error?.response?.data?.error?.message ??
                  T("Invalid verification code")
                : undefined,
              otpError: !row?.is_twofa
                ? error?.response?.data?.error?.message ??
                  T("Invalid verification code")
                : undefined,
            };
          } finally {
            setLoading(false);
          }
        },
      });
    }
  };

  const withDrawConfirmPassword = async () => {
    try {
      setLoading(true);
      const result = await postWithdrawConfirmV2({
        transactionId: row?.id,
        destWalletAddress: row?.dest_wallet_address || "",
        password: !isUserSocial ? password : undefined,
      });
      if (result.status === 200) {
        setLoading(false);
        return true;
      } else {
        if (result?.data?.error?.validates) {
          setErrors(result?.data?.error?.validates || []);
        } else {
          Notification.error(
            result?.data?.error?.message ??
              "Failed to confirm withdrawal request"
          );
        }
        return false;
      }
    } catch (error) {
      console.error("Error confirming withdrawal:", error);
      setAlert({
        type: "error",
        text: T("Failed to confirm withdrawal request"),
      });
      setErrors(error?.response?.data?.error?.validates || []);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form}>
      <Modal onClose={onClose}>
        <Modal.ModalBg onClose={onClose} />
        <Modal.Container
          width="800px"
          style={{ backgroundColor: "rgb(245, 245, 245)" }}
          onClose={onClose}
        >
          <Modal.ContentWraper className="pb-2">
            <Title>{T("Withdrawal Request")}</Title>
            {row ? (
              <Body>
                <Row>
                  <Cell>
                    <CellTitle>{T("Transaction ID")}</CellTitle>
                    <CellValue>{row?.id}</CellValue>
                  </Cell>
                  <Cell>
                    <CellTitle>{T("Coin")}</CellTitle>
                    <CellValue>
                      {T(getNameByCode(row?.dest_currency_code))} (
                      {row?.dest_currency_code || ""})
                    </CellValue>
                  </Cell>
                </Row>
                <WalletDetailNotify
                  style={{
                    marginTop: 0,
                    marginBottom: 32,
                    background: "#F5AA194D",
                    borderRadius: 10,
                    padding: "24px 30px",
                    flexWrap: "wrap",
                    flexDirection: "column",
                  }}
                >
                  <div className="w-full flex">
                    <InfoIcon />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: T("withdraw.confirm").replace(
                          "{coin_name}",
                          `<b>${T(getNameByCode(row?.dest_currency_code))}</b>`
                        ),
                      }}
                    ></div>
                  </div>
                  <div className="w-full flex">
                    <InfoIcon />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: T("withdraw.confirm2"),
                      }}
                    ></div>
                  </div>
                </WalletDetailNotify>
                <Row style={{ marginTop: 0, marginBottom: 20 }}>
                  <Cell>
                    <CellTitle>{T("Recipient’s Address")}</CellTitle>
                    {!editAble ? (
                      <div className="flex flex-col">
                        <CellValue>{row?.dest_wallet_address || ""}</CellValue>
                        <div
                          className="text-[#F3850F] text-[14px]"
                          onClick={() => {
                            onClose("");
                          }}
                        >
                          {T("Want to change?")}
                        </div>
                      </div>
                    ) : (
                      <CellValue>
                        <Form.Item
                          style={{ width: "100%", marginTop: 15 }}
                          name={"dest_wallet_address"}
                          {...errorView(errors, "destWalletAddress")}
                        >
                          <AuthFormInput
                            value={row?.dest_wallet_address || ""}
                            onChange={(event) => {
                              setRow(
                                produce((draft) => {
                                  draft.dest_wallet_address =
                                    event.target.value;
                                })
                              );
                              setErrors(
                                produce((draft) => {
                                  draft.splice(
                                    draft.findIndex(
                                      (item) => item.key === "destWalletAddress"
                                    ),
                                    1
                                  );
                                })
                              );
                            }}
                            placeholder={T("Address")}
                          />
                        </Form.Item>
                      </CellValue>
                    )}
                  </Cell>
                </Row>
                <Row>
                  <Cell>
                    <CellTitle>{T("Amount")}</CellTitle>
                    <CellValue>
                      {formatCurrency(row?.amount || "", null, getCurrency())}{" "}
                      {row?.dest_currency_code || ""}
                    </CellValue>
                  </Cell>
                </Row>
                <Row style={{ marginTop: 0, marginBottom: 32 }}>
                  <Cell>
                    <CellTitle>{T("Fee")}</CellTitle>
                    <CellValue>
                      {formatCurrency(
                        row?.fee_amount || "",
                        null,
                        getCurrency()
                      )}{" "}
                      {row?.dest_currency_code || ""}
                    </CellValue>
                  </Cell>
                </Row>
                {!isUserSocial ? (
                  <Row>
                    <Cell>
                      <CellTitle
                        style={{
                          marginBottom: 12,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {T("Confirm Password")}
                        <TooltipView
                          color={"#EAF2FF"}
                          overlayClassName={"note-tooltip"}
                          title={T(
                            "Please enter the password that you use for Art Walk mobile app and ams.aiavatar.fun"
                          )}
                        >
                          <InfoTooltipIcon style={{ marginLeft: 9 }} />
                        </TooltipView>
                      </CellTitle>
                      <CellValue>
                        <Form.Item
                          {...errorView(errors, "password")}
                          name={"password"}
                          style={{
                            width: "100%",
                            marginTop: 12,
                            marginBottom: 36,
                          }}
                        >
                          <FormInput
                            type="password"
                            value={password}
                            onChange={(event) => {
                              setSearchParams(
                                (prev) => {
                                  const newParams = new URLSearchParams(prev);
                                  newParams.set(
                                    "password",
                                    encodeURIComponent(
                                      encodeText(event.target.value)
                                    )
                                  );
                                  return newParams;
                                },
                                {
                                  replace: true,
                                }
                              );
                              setErrors(
                                produce((draft) => {
                                  draft.splice(
                                    draft.findIndex(
                                      (item) => item.key === "password"
                                    ),
                                    1
                                  );
                                })
                              );
                            }}
                            placeholder={T("Enter your password")}
                          />
                        </Form.Item>
                      </CellValue>
                    </Cell>
                  </Row>
                ) : null}
              </Body>
            ) : null}
            <Footer>
              <ContainerRow>
                <FormButtonCancel3
                  style={{ marginRight: 8 }}
                  onClick={() => onClose()}
                >
                  {T("Cancel")}
                </FormButtonCancel3>
                <FormButton2
                  disabled={
                    !(
                      !!row.dest_wallet_address &&
                      ((!isUserSocial && !!password) || isUserSocial)
                    ) ||
                    loading ||
                    verification.loading
                  }
                  style={{ marginLeft: 8 }}
                  onClick={() => onSubmit()}
                >
                  {T("Withdraw")}
                </FormButton2>
              </ContainerRow>
            </Footer>
          </Modal.ContentWraper>
        </Modal.Container>
      </Modal>
    </Form>
  );
}
